export default __webpack_public_path__ + "static/media/exclamation.fc8b703d.svg";